import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { Role } from '../../../pages/users/user.model';
import { UsersService } from '../../../pages/users/users.service';
import { StudyPlan } from './study-plan.model';
import { GeneralService } from '../../services/general.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-select-study-plan',
  templateUrl: './select-study-plan.component.html',
  styleUrls: ['./select-study-plan.component.scss'],
  providers: [ UsersService, GeneralService ]
})
export class SelectStudyPlanComponent implements OnInit {
  public studyPlans: StudyPlan[];
  public studyPlansCtrl = new FormControl();
  @Output() public onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private usersService: UsersService, private generalService: GeneralService) {

  }

  ngOnInit() {
    this.generalService.getStudyPlans(AuthService.getUser().business ? AuthService.getUser().business.name : 'notavailable').subscribe(studyPlans => {
      this.studyPlans = studyPlans;
    });
  }

  change(e) {
    console.log(e);
    this.onChange.emit(e);
  }

}